


















import { defineComponent } from '@vue/composition-api';
import { ContactPoint } from '@/store/types';

export default defineComponent({
	props: {
		contact: {
			type: Object as () => ContactPoint,
			required: true,
		},
	},
});
